import {Injectable} from '@angular/core';
import {Message} from '@catmodules/widgets/growl/types';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class MessageService {

  private messageSource = new Subject<Message | Message[]>();

  messageObserver = this.messageSource.asObservable();

  add(message: Message) {
    if (message) {
      this.messageSource.next(message);
    }
  }

  addAll(messages: Message[]) {
    if (messages && messages.length) {
      this.messageSource.next(messages);
    }
  }

  clear() {
    this.messageSource.next(null);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/widgets/growl/services/message.service.ts